/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamGridFilterViewModel } from "../types/ExamGridFilterViewModel.ts";

export const examGridFilterViewModelSchema = z.object({
  disciplineId: z.number().int().nullish(),
  companyId: z.number().int().nullish(),
  title: z.string().nullish(),
  active: z.boolean().nullish(),
  examType: z.number().int().nullish(),
  status: z.number().int().nullish(),
  pageNumber: z.optional(z.number().int()),
  pageSize: z.optional(z.number().int()),
  sortField: z.string().nullish(),
  sortDirection: z.string().nullish(),
}) as unknown as ToZod<ExamGridFilterViewModel>;
